<template>
  <el-dialog
    :title="(isEdit ? '编辑' : '添加') + '配件称重信息'"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="400px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      status-icon
      :rules="rules"
      ref="form"
      label-position="right"
      label-width="100px"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="配件名称" prop="PartName">
            <el-input
              v-model="form.PartName"
              placeholder="配件名称"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="重量(KG)" prop="Weight">
            <el-input v-model="form.Weight" placeholder="重量(KG)"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="save" :loading="loading"
        >保 存</el-button
      >
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
    
<script>
export default {
  props: ["item"],
  components: {},
  data() {
    return {
      visible: false,
      loading: false,
      isable: true,
      isEdit: false,
      form: {},
      rules: {
        // OrgId: [
        //     {
        //         required: true,
        //         message: "不可为空",
        //     },
        // ],
        // PartName: [
        //     {
        //         required: true,
        //         message: "不可为空",
        //     },
        //     this.$g.validLen(50),
        // ],
        Weight: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validLen(10),
        ],
      },
    };
  },
  computed: {},
  watch: {
    item: {
      handler: function (v) {
        if (v.KeyId) {
          this.isEdit = true;
          this.$get("WeighingPart/GetWeighingPartByID", {
            KeyId: v.KeyId,
          }).then((r) => {
            this.init({ ...r.Result });
          });
        } else {
          this.init({});
          this.isEdit = false;
        }
        this.visible = true;
      },
    },
  },
  methods: {
    init(form) {
      this.form = { ...form };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }
        let params = { ...this.form };
        this.loading = true;
        if (this.isEdit) {
          this.$put("WeighingPart/Edit", params).then((r) => {
            this.$message.success("修改成功");
            this.visible = false;
            this.$emit("success");
          });
        } else {
          this.$post("WeighingPart/Add", params).then((r) => {
            this.$message.success("添加成功");
            this.visible = false;
            this.$emit("success");
          });
        }
        this.loading = false;
      });
    },
  },
};
</script>    
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
  margin-top: 10px;
  @include font_color("text-color2");
}
</style>